import { render } from "./afinputBox.vue?vue&type=template&id=972bc45c&scoped=true"
import script from "./afinputBox.vue?vue&type=script&lang=js"
export * from "./afinputBox.vue?vue&type=script&lang=js"

import "./afinputBox.vue?vue&type=style&index=0&id=972bc45c&scoped=true&lang=css"

import exportComponent from "D:\\WebstormProjects\\authpage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972bc45c"]])

export default __exports__